import React from 'react';

import cx from 'classnames';

export const IconName = {
  Android: 'icon-android',
  Apple: 'icon-apple',
  Close: 'icon-close',
  Facebook: 'icon-facebook',
  Instagram: 'icon-instagram',
  Linkedin: 'icon-linkedin',
  Tiktok: 'icon-tiktok',
  Snapchat: 'icon-snapchat',
  Twitter: 'icon-twitter',
  Pinterest: 'icon-pinterest',
  Youtube: 'icon-youtube',
  Menu: 'icon-menu',
  GenericChevronDown: 'generic-chevron-down',
  GenericChevronBack: 'generic-chevron-back',
  GenericChevronForward: 'generic-chevron-forward',
  GenericGlobe: 'generic-globe',
  QrCode: 'qr-code',
  GlobalTrendsMicroMance: 'global-trends-micro-mance',
  GlobalTrendsDWM: 'global-trends-dwm',
  GlobalTrendsOnTheSamePage: 'global-trends-on-the-same-page',
  GlobalTrendsMaleCasting: 'global-trends-male-casting',
  GlobalTrendsFutureProofing: 'global-trends-future-proofing',
  GlobalTrendsGuysThatGetIt: 'global-trends-guys-that-get-it',
  FeatureDiscover: 'icon-feature-discover',
  FeatureInstantMatch: 'icon-feature-instance-match',
};

export const mapNameToIcon = {
  [IconName.Android]: (
    <svg aria-hidden={true} id="icon-android" viewBox="0 0 24 24">
      <path d="M9.41 18.864a3.078 3.078 0 0 1-2.32-2.983V9.833h10.82v6.048a3.078 3.078 0 0 1-2.32 2.983v1.977a1.16 1.16 0 0 1-2.317 0v-1.883h-1.546v1.883a1.16 1.16 0 1 1-2.318 0v-1.977zm1.14-14.759a5.473 5.473 0 0 1 1.95-.356c.687 0 1.345.126 1.95.356L16.055 2l.618.456-1.51 1.982c1.64.914 2.746 2.647 2.746 4.634H7.091c0-1.987 1.106-3.72 2.746-4.634l-1.51-1.982L8.945 2l1.605 2.105zM5.16 9.072c.64 0 1.158.52 1.158 1.16v5.286a1.16 1.16 0 0 1-2.318 0V10.23c0-.64.519-1.159 1.16-1.159zm14.68 0c.641 0 1.16.52 1.16 1.16v5.286a1.16 1.16 0 0 1-2.318 0V10.23c0-.64.519-1.159 1.159-1.159zM9.796 6.03a.383.383 0 0 0-.386.38c0 .21.173.38.386.38h.773c.214 0 .387-.17.387-.38s-.173-.38-.387-.38h-.773zm4.637 0a.383.383 0 0 0-.387.38c0 .21.173.38.387.38h.773c.213 0 .386-.17.386-.38s-.173-.38-.386-.38h-.773z"></path>
    </svg>
  ),
  [IconName.Apple]: (
    <svg aria-hidden={true} id="icon-apple" viewBox="0 0 24 24">
      <path d="M14.887 3.876c.689-.761 1.15-1.82 1.024-2.876-.987.036-2.188.605-2.895 1.364-.634.675-1.19 1.751-1.043 2.785 1.103.078 2.23-.513 2.914-1.273M20 14.203c-.024.062-.414 1.292-1.362 2.559-.817 1.097-1.668 2.192-3.008 2.213-1.314.024-1.737-.714-3.241-.714s-1.974.693-3.219.738c-1.294.046-2.275-1.186-3.102-2.278-1.69-2.235-2.976-6.317-1.248-9.069.862-1.368 2.398-2.233 4.066-2.256 1.272-.02 2.468.782 3.244.782.777 0 2.23-.97 3.762-.827.638.027 2.437.237 3.594 1.786-.095.055-2.147 1.147-2.125 3.425.026 2.724 2.609 3.63 2.639 3.641"></path>
    </svg>
  ),
  [IconName.Close]: (
    <svg aria-hidden={true} id="icon-close" viewBox="0 0 24 24">
      <path d="M11.728 10.314l5.657-5.657 1.414 1.414-5.657 5.657 5.657 5.657-1.414 1.414-5.657-5.657L6.07 18.8l-1.414-1.414 5.657-5.657L4.657 6.07 6.07 4.657l5.657 5.657z" />
    </svg>
  ),
  [IconName.Facebook]: (
    <svg aria-hidden={true} id="icon-facebook" viewBox="0 0 24 24">
      <path d="M22 12.061C22 6.505 17.523 2 12 2S2 6.505 2 12.061c0 5.022 3.657 9.184 8.438 9.939v-7.03h-2.54V12.06h2.54V9.845c0-2.522 1.492-3.915 3.777-3.915 1.094 0 2.238.197 2.238.197v2.476h-1.26c-1.243 0-1.63.775-1.63 1.57v1.888h2.773l-.443 2.908h-2.33V22c4.78-.755 8.437-4.917 8.437-9.939Z" />
    </svg>
  ),
  [IconName.Linkedin]: (
    <svg aria-hidden={true} id="icon-linkedin" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M20.52 2H3.476C2.662 2 2 2.646 2 3.441v17.116C2 21.354 2.662 22 3.476 22H20.52c.815 0 1.48-.646 1.48-1.443V3.44C22 2.646 21.335 2 20.52 2Zm-4.442 17.043h2.964v-5.235c0-2.57-.554-4.547-3.558-4.547-1.443 0-2.41.791-2.807 1.541h-.04V9.498H9.792v9.545h2.964V14.32c0-1.245.237-2.45 1.78-2.45 1.522 0 1.542 1.423 1.542 2.53v4.642ZM4.728 6.473a1.72 1.72 0 1 0 3.44.001 1.72 1.72 0 0 0-3.44 0Zm3.204 12.57H4.965V9.5h2.967v9.544Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  [IconName.Youtube]: (
    <svg aria-hidden={true} id="icon-youtube" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M21.005 6.085c.6.6.795 1.962.795 1.962s.2 1.6.2 3.2v1.5c0 1.6-.2 3.2-.2 3.2s-.195 1.362-.795 1.962c-.685.71-1.446.783-1.875.824-.047.004-.09.008-.129.013-2.799.2-7.001.206-7.001.206s-5.2-.047-6.8-.198a4.527 4.527 0 0 0-.273-.038c-.507-.06-1.301-.155-1.932-.807-.6-.6-.795-1.963-.795-1.963s-.2-1.6-.2-3.2v-1.5c0-1.599.2-3.199.2-3.199s.195-1.362.795-1.962c.686-.71 1.446-.783 1.875-.824L5 5.248c2.799-.2 6.997-.2 6.997-.2h.008s4.199 0 6.997.2l.129.013c.43.041 1.19.114 1.875.824ZM9.933 9.009l.001 5.555 5.403-2.768L9.933 9.01Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  [IconName.Instagram]: (
    <svg aria-hidden={true} id="icon-instagram" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M6.864 12a5.135 5.135 0 1 0 10.27 0 5.135 5.135 0 0 0-10.27 0ZM12 15.335a3.333 3.333 0 1 1 0-6.667 3.333 3.333 0 0 1 0 6.667Z"
        clipRule="evenodd"
      />
      <path d="M16.138 6.662a1.2 1.2 0 1 0 2.4 0 1.2 1.2 0 0 0-2.4 0Z" />
      <path
        fillRule="evenodd"
        d="M12 2c-2.716 0-3.056.012-4.123.06-1.064.049-1.791.218-2.427.465a4.901 4.901 0 0 0-1.772 1.153A4.901 4.901 0 0 0 2.525 5.45c-.247.636-.416 1.363-.465 2.427C2.012 8.944 2 9.284 2 12s.012 3.056.06 4.123c.049 1.064.218 1.791.465 2.427a4.902 4.902 0 0 0 1.153 1.772 4.902 4.902 0 0 0 1.772 1.153c.636.247 1.363.416 2.427.465 1.067.048 1.407.06 4.123.06s3.056-.012 4.123-.06c1.064-.049 1.791-.218 2.427-.465a4.902 4.902 0 0 0 1.772-1.153 4.902 4.902 0 0 0 1.153-1.772c.247-.636.416-1.363.465-2.427.048-1.067.06-1.407.06-4.123s-.012-3.056-.06-4.123c-.049-1.064-.218-1.791-.465-2.427a4.902 4.902 0 0 0-1.153-1.772 4.902 4.902 0 0 0-1.772-1.153c-.636-.247-1.363-.416-2.427-.465C15.056 2.012 14.716 2 12 2Zm-.001 1.802c2.67 0 2.986.01 4.04.058.976.045 1.505.208 1.858.345.466.181.8.398 1.15.748.35.35.566.683.747 1.15.137.352.3.882.345 1.857.048 1.054.058 1.37.058 4.04s-.01 2.987-.058 4.041c-.045.975-.208 1.505-.345 1.857-.18.467-.398.8-.748 1.15-.35.35-.683.567-1.15.748-.352.137-.881.3-1.856.344-1.054.048-1.37.059-4.041.059-2.67 0-2.987-.01-4.041-.059-.975-.044-1.504-.207-1.857-.344a3.098 3.098 0 0 1-1.15-.748 3.098 3.098 0 0 1-.748-1.15c-.137-.352-.3-.882-.344-1.857-.048-1.054-.058-1.37-.058-4.04s.01-2.987.058-4.041c.044-.975.207-1.505.344-1.857.182-.467.398-.8.748-1.15.35-.35.683-.567 1.15-.748.353-.137.882-.3 1.857-.345 1.055-.048 1.37-.058 4.04-.058Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  [IconName.Snapchat]: (
    <svg aria-hidden={true} id="icon-snapchat" viewBox="0 0 24 24">
      <path d="M5.98 10.237c-.069-.693-.048-1.462-.048-2.287 0-3.286 2.69-5.95 6.007-5.95 3.318 0 6.007 2.664 6.007 5.95 0 1.028.032 2.022-.119 2.895 1.056-.104 2.88-.185 2.768.519-.157.986-2.81 1.38-2.81 1.38s-.33 1.567.808 2.991c1.138 1.424 3.809 1.555 4.356 2.01.547.456-3.476 1.48-3.476 1.48s.453 1.339-.29 1.526c-.743.186-2.907-.722-2.907-.722s-2.894 2.049-5.36 1.969c-2.467-.08-3.927-2.272-3.927-2.272s-2.1.47-2.862.117c-.763-.351-.071-1.47-.071-1.47s-3.248-.442-3.047-1.083c.201-.64 2.096-.777 4.087-2.23 1.99-1.453 1.114-3.14 1.114-3.14s-1.923-.523-2.083-1.394c-.089-.48.926-.43 1.854-.29z" />
    </svg>
  ),
  [IconName.Twitter]: (
    <svg aria-hidden={true} id="icon-twitter" viewBox="0 0 24 24">
      <path d="M14.069 10.464 21.306 2H19.59l-6.284 7.35L8.288 2H2.5l7.59 11.114L2.5 21.99h1.715l6.636-7.761 5.3 7.76h5.788l-7.87-11.525Zm-2.349 2.747-.769-1.106-6.118-8.806h2.634l4.938 7.107.768 1.106 6.419 9.238h-2.634l-5.238-7.538Z" />
    </svg>
  ),
  [IconName.Pinterest]: (
    <svg aria-hidden={true} id="icon-pinterest" viewBox="0 0 24 24">
      <path d="M22 12c0 1.814-.447 3.487-1.341 5.02a9.956 9.956 0 0 1-3.64 3.639C15.488 21.553 13.815 22 12 22c-.963 0-1.91-.139-2.839-.417.513-.807.851-1.519 1.016-2.135.078-.295.313-1.211.703-2.747.174.338.49.631.95.878.46.248.956.372 1.485.372 1.05 0 1.988-.298 2.813-.892.824-.595 1.462-1.413 1.914-2.455.451-1.041.677-2.213.677-3.515 0-.99-.259-1.919-.775-2.787-.517-.868-1.265-1.575-2.246-2.122-.981-.547-2.088-.82-3.32-.82a8.36 8.36 0 0 0-2.552.377c-.79.252-1.461.586-2.012 1.003a6.857 6.857 0 0 0-1.42 1.438 5.954 5.954 0 0 0-.872 1.687 5.682 5.682 0 0 0-.28 1.744c0 .903.174 1.697.521 2.383.347.686.855 1.168 1.523 1.445.26.105.426.018.495-.26.018-.06.052-.195.104-.404.053-.208.087-.338.105-.39.052-.2.004-.386-.144-.56-.442-.53-.664-1.185-.664-1.966 0-1.311.454-2.437 1.361-3.38.907-.941 2.094-1.412 3.561-1.412 1.31 0 2.333.356 3.067 1.068.733.712 1.1 1.636 1.1 2.773 0 1.476-.298 2.73-.892 3.763-.595 1.033-1.356 1.55-2.285 1.55-.53 0-.955-.19-1.276-.567-.322-.377-.421-.83-.3-1.36.07-.304.185-.71.345-1.218.16-.508.291-.955.39-1.34.1-.387.15-.715.15-.984 0-.434-.117-.794-.35-1.08-.235-.287-.57-.43-1.004-.43-.538 0-.993.247-1.367.742-.373.495-.56 1.11-.56 1.849 0 .633.109 1.163.326 1.588l-1.29 5.443c-.147.608-.203 1.376-.168 2.305-1.789-.79-3.234-2.01-4.336-3.66C2.55 15.859 2 14.024 2 12c0-1.814.447-3.487 1.341-5.02a9.955 9.955 0 0 1 3.64-3.639C8.512 2.447 10.185 2 12 2s3.487.447 5.02 1.341a9.955 9.955 0 0 1 3.639 3.64C21.553 8.512 22 10.185 22 12Z" />
    </svg>
  ),
  [IconName.Tiktok]: (
    <svg aria-hidden={true} id="icon-tiktok" viewBox="0 0 24 24">
      <path
        fill="#000"
        d="M20 2H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z"
      />
      <path
        fill="#25F4EE"
        d="M11.061 10.654v-.543a4.109 4.109 0 0 0-.555-.04 4.115 4.115 0 0 0-2.36 7.489 4.09 4.09 0 0 1-1.091-2.804 4.098 4.098 0 0 1 4.006-4.102Z"
      />
      <path
        fill="#25F4EE"
        d="M11.159 16.649a1.902 1.902 0 0 0 1.889-1.822l.008-8.953 1.624.001-.003-.013a3.124 3.124 0 0 1-.052-.568h-2.237l-.004 8.966a1.881 1.881 0 0 1-1.877 1.81c-.315 0-.611-.08-.872-.217.341.474.897.796 1.524.796ZM17.736 8.931v-.525a3.092 3.092 0 0 1-1.695-.504c.435.499 1.025.886 1.695 1.03Z"
      />
      <path
        fill="#FE2C55"
        d="M16.041 7.902a3.099 3.099 0 0 1-.765-2.04h-.61a3.132 3.132 0 0 0 1.375 2.04ZM10.506 12.29c-1.037 0-1.893.862-1.893 1.899 0 .722.422 1.349 1.021 1.664a1.868 1.868 0 0 1-.356-1.097c0-1.037.844-1.88 1.88-1.88.194 0 .38.032.556.087v-2.284a4.11 4.11 0 0 0-.555-.04c-.033 0-.065 0-.098.002h-.008l-.006 1.729a1.754 1.754 0 0 0-.54-.08Z"
      />
      <path
        fill="#FE2C55"
        d="m17.736 8.905-.01-.002v1.727a5.337 5.337 0 0 1-3.116-1.012v4.57a4.101 4.101 0 0 1-4.104 4.107 4.083 4.083 0 0 1-2.36-.735 4.106 4.106 0 0 0 3.012 1.314 4.122 4.122 0 0 0 4.118-4.118V10.21a5.32 5.32 0 0 0 3.113 1V8.975c-.224 0-.442-.024-.652-.07Z"
      />
      <path
        fill="#fff"
        d="M14.625 14.189V9.642a5.32 5.32 0 0 0 3.112 1.001V8.905a3.114 3.114 0 0 1-1.695-1.003 3.118 3.118 0 0 1-1.365-2.04H13.04l-.003 8.965a1.877 1.877 0 0 1-3.401 1.026 1.881 1.881 0 0 1-1.009-1.664c0-1.037.844-1.88 1.88-1.88.194 0 .38.031.556.086v-1.754a4.122 4.122 0 0 0-4.021 4.116c0 1.082.42 2.068 1.106 2.803.668.47 1.482.747 2.36.747a4.122 4.122 0 0 0 4.117-4.118Z"
      />
    </svg>
  ),
  [IconName.Menu]: (
    <svg aria-hidden={true} id="icon-menu" viewBox="0 0 24 24">
      <path d="M4 5h16v2H4V5zm0 6h16v2H4v-2zm0 6h16v2H4v-2z" fill="currentColor" />
    </svg>
  ),
  [IconName.GenericChevronDown]: (
    <svg aria-hidden={true} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M17.6 7.4c.5-.6 1.4-.5 2 0 .5.7.5 1.6 0 2.2l-6.8 7c-.6.5-1.5.5-2 0l-6.9-7c-.5-.6-.5-1.5 0-2.1.6-.6 1.5-.7 2 0l5.8 5.9 5.9-6Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  [IconName.GenericChevronForward]: (
    <svg aria-hidden={true} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M7.4 17.6c-.6.5-.5 1.4 0 2 .7.5 1.6.5 2.2 0l7-6.8c.5-.6.5-1.5 0-2l-7-6.9c-.6-.5-1.5-.5-2.1 0-.6.6-.7 1.5 0 2l5.9 5.8-6 5.9Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  [IconName.GenericChevronBack]: (
    <svg aria-hidden={true} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M16.6 17.6c.6.5.5 1.4 0 2-.7.5-1.6.5-2.2 0l-7-6.8c-.5-.6-.5-1.5 0-2l7-6.9c.6-.5 1.5-.5 2.1 0 .6.6.7 1.5 0 2l-5.9 5.8 6 5.9Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  [IconName.GenericGlobe]: (
    <svg aria-hidden={true} viewBox="0 0 21 21">
      <path d="M10.5.1C4.986.1.5 4.584.5 10.1c0 5.513 4.486 10 10 10s10-4.487 10-10c0-5.515-4.486-10-10-10Zm.489 16.944a.573.573 0 0 1-.425.198h-.128a.57.57 0 0 1-.425-.198c-.238-.276-.519-.732-.784-1.42a11.528 11.528 0 0 1-.505-1.756.143.143 0 0 1 .136-.172 53.473 53.473 0 0 1 3.284 0 .143.143 0 0 1 .136.172c-.134.639-.303 1.23-.505 1.756-.264.688-.545 1.144-.784 1.42Zm-.489-5.516c-.662 0-1.316.011-1.953.034a.142.142 0 0 1-.148-.133 20.787 20.787 0 0 1 0-2.66.142.142 0 0 1 .148-.133 54.527 54.527 0 0 0 3.906 0 .142.142 0 0 1 .148.133 20.759 20.759 0 0 1 0 2.66.142.142 0 0 1-.148.133 54.436 54.436 0 0 0-1.953-.034Zm-7.143-1.429c0-.62.08-1.22.229-1.793a.143.143 0 0 1 .161-.105c.712.117 1.517.215 2.385.29a.142.142 0 0 1 .13.152 22.422 22.422 0 0 0 0 2.913.143.143 0 0 1-.13.151c-.868.075-1.673.173-2.385.29a.142.142 0 0 1-.161-.104 7.143 7.143 0 0 1-.229-1.794Zm6.657-6.947a.57.57 0 0 1 .43-.196h.112a.57.57 0 0 1 .43.196c.24.275.521.732.787 1.422.22.57.4 1.22.538 1.923a53.536 53.536 0 0 1-3.622 0c.139-.704.319-1.352.538-1.923.266-.69.547-1.147.787-1.422Zm4.854 5.34a31.642 31.642 0 0 0 2.385-.29.142.142 0 0 1 .161.104 7.142 7.142 0 0 1 0 3.587.143.143 0 0 1-.161.105 31.662 31.662 0 0 0-2.385-.29.142.142 0 0 1-.13-.152 22.445 22.445 0 0 0 0-2.913.143.143 0 0 1 .13-.151Zm1.356-2.3c-.505.068-1.052.126-1.63.175a.143.143 0 0 1-.153-.116 14.615 14.615 0 0 0-.567-2.159.143.143 0 0 1 .207-.17 7.196 7.196 0 0 1 2.24 2.044c.063.088.01.211-.097.226Zm-9.098-2.1c-.233.66-.423 1.39-.567 2.158a.143.143 0 0 1-.153.116 32.176 32.176 0 0 1-1.63-.175.143.143 0 0 1-.097-.226 7.196 7.196 0 0 1 2.24-2.045.143.143 0 0 1 .207.17v.001Zm-2.35 9.915a32.151 32.151 0 0 1 1.63-.176.143.143 0 0 1 .153.117c.144.769.334 1.497.567 2.158a.143.143 0 0 1-.207.171 7.197 7.197 0 0 1-2.24-2.045.143.143 0 0 1 .097-.226v.001Zm9.098 2.1c.233-.662.423-1.39.567-2.159a.143.143 0 0 1 .153-.116c.579.048 1.125.107 1.63.176.107.014.16.137.097.225a7.196 7.196 0 0 1-2.24 2.045.143.143 0 0 1-.207-.17v-.001Z" />
    </svg>
  ),
  [IconName.QrCode]: (
    <svg
      aria-hidden={true}
      viewBox="83.3 83.3 833.4 833.4"
      width={145}
      height={145}
      fill="currentColor"
    >
      <rect x="83.3" y="370.7" width="28.7" height="28.7" />
      <rect x="83.3" y="428.2" width="28.7" height="28.7" />
      <rect x="83.3" y="485.6" width="28.7" height="28.7" />
      <rect x="83.3" y="514.4" width="28.7" height="28.7" />
      <rect x="83.3" y="543.1" width="28.7" height="28.7" />
      <rect x="83.3" y="571.8" width="28.7" height="28.7" />
      <rect x="83.3" y="600.6" width="28.7" height="28.7" />
      <rect x="83.3" y="629.3" width="28.7" height="28.7" />
      <rect x="83.3" y="658" width="28.7" height="28.7" />
      <rect x="112.1" y="571.8" width="28.7" height="28.7" />
      <rect x="112.1" y="629.3" width="28.7" height="28.7" />
      <rect x="140.8" y="313.2" width="28.7" height="28.7" />
      <rect x="140.8" y="342" width="28.7" height="28.7" />
      <rect x="140.8" y="370.7" width="28.7" height="28.7" />
      <rect x="140.8" y="399.4" width="28.7" height="28.7" />
      <rect x="140.8" y="428.2" width="28.7" height="28.7" />
      <rect x="140.8" y="514.4" width="28.7" height="28.7" />
      <rect x="140.8" y="543.1" width="28.7" height="28.7" />
      <rect x="140.8" y="571.8" width="28.7" height="28.7" />
      <rect x="169.5" y="342" width="28.7" height="28.7" />
      <rect x="169.5" y="370.7" width="28.7" height="28.7" />
      <rect x="169.5" y="399.4" width="28.7" height="28.7" />
      <rect x="169.5" y="456.9" width="28.7" height="28.7" />
      <rect x="169.5" y="485.6" width="28.7" height="28.7" />
      <rect x="169.5" y="514.4" width="28.7" height="28.7" />
      <rect x="169.5" y="543.1" width="28.7" height="28.7" />
      <rect x="169.5" y="600.6" width="28.7" height="28.7" />
      <rect x="169.5" y="629.3" width="28.7" height="28.7" />
      <rect x="198.3" y="313.2" width="28.7" height="28.7" />
      <rect x="198.3" y="514.4" width="28.7" height="28.7" />
      <rect x="198.3" y="571.8" width="28.7" height="28.7" />
      <rect x="198.3" y="600.6" width="28.7" height="28.7" />
      <rect x="198.3" y="658" width="28.7" height="28.7" />
      <rect x="227" y="313.2" width="28.7" height="28.7" />
      <rect x="227" y="342" width="28.7" height="28.7" />
      <rect x="227" y="370.7" width="28.7" height="28.7" />
      <rect x="227" y="456.9" width="28.7" height="28.7" />
      <rect x="227" y="485.6" width="28.7" height="28.7" />
      <rect x="227" y="514.4" width="28.7" height="28.7" />
      <rect x="227" y="543.1" width="28.7" height="28.7" />
      <rect x="227" y="571.8" width="28.7" height="28.7" />
      <rect x="227" y="629.3" width="28.7" height="28.7" />
      <rect x="227" y="658" width="28.7" height="28.7" />
      <rect x="255.7" y="313.2" width="28.7" height="28.7" />
      <rect x="255.7" y="370.7" width="28.7" height="28.7" />
      <rect x="255.7" y="428.2" width="28.7" height="28.7" />
      <rect x="255.7" y="485.6" width="28.7" height="28.7" />
      <rect x="255.7" y="543.1" width="28.7" height="28.7" />
      <rect x="255.7" y="600.6" width="28.7" height="28.7" />
      <rect x="255.7" y="658" width="28.7" height="28.7" />
      <rect x="284.5" y="370.7" width="28.7" height="28.7" />
      <rect x="284.5" y="399.4" width="28.7" height="28.7" />
      <rect x="284.5" y="428.2" width="28.7" height="28.7" />
      <rect x="284.5" y="456.9" width="28.7" height="28.7" />
      <rect x="284.5" y="485.6" width="28.7" height="28.7" />
      <rect x="284.5" y="514.4" width="28.7" height="28.7" />
      <rect x="284.5" y="543.1" width="28.7" height="28.7" />
      <rect x="284.5" y="629.3" width="28.7" height="28.7" />
      <rect x="313.2" y="112.1" width="28.7" height="28.7" />
      <rect x="313.2" y="198.3" width="28.7" height="28.7" />
      <rect x="313.2" y="255.7" width="28.7" height="28.7" />
      <rect x="313.2" y="313.2" width="28.7" height="28.7" />
      <rect x="313.2" y="342" width="28.7" height="28.7" />
      <rect x="313.2" y="456.9" width="28.7" height="28.7" />
      <rect x="313.2" y="485.6" width="28.7" height="28.7" />
      <rect x="313.2" y="543.1" width="28.7" height="28.7" />
      <rect x="313.2" y="629.3" width="28.7" height="28.7" />
      <rect x="313.2" y="658" width="28.7" height="28.7" />
      <rect x="313.2" y="686.8" width="28.7" height="28.7" />
      <rect x="313.2" y="744.3" width="28.7" height="28.7" />
      <rect x="313.2" y="773" width="28.7" height="28.7" />
      <rect x="313.2" y="830.5" width="28.7" height="28.7" />
      <rect x="342" y="83.3" width="28.7" height="28.7" />
      <rect x="342" y="198.3" width="28.7" height="28.7" />
      <rect x="342" y="284.5" width="28.7" height="28.7" />
      <rect x="342" y="342" width="28.7" height="28.7" />
      <rect x="342" y="428.2" width="28.7" height="28.7" />
      <rect x="342" y="456.9" width="28.7" height="28.7" />
      <rect x="342" y="514.4" width="28.7" height="28.7" />
      <rect x="342" y="543.1" width="28.7" height="28.7" />
      <rect x="342" y="600.6" width="28.7" height="28.7" />
      <rect x="342" y="686.8" width="28.7" height="28.7" />
      <rect x="342" y="715.5" width="28.7" height="28.7" />
      <rect x="342" y="744.3" width="28.7" height="28.7" />
      <rect x="342" y="773" width="28.7" height="28.7" />
      <rect x="342" y="801.7" width="28.7" height="28.7" />
      <rect x="342" y="859.2" width="28.7" height="28.7" />
      <rect x="342" y="887.9" width="28.7" height="28.7" />
      <rect x="370.7" y="112.1" width="28.7" height="28.7" />
      <rect x="370.7" y="169.5" width="28.7" height="28.7" />
      <rect x="370.7" y="227" width="28.7" height="28.7" />
      <rect x="370.7" y="255.7" width="28.7" height="28.7" />
      <rect x="370.7" y="313.2" width="28.7" height="28.7" />
      <rect x="370.7" y="342" width="28.7" height="28.7" />
      <rect x="370.7" y="658" width="28.7" height="28.7" />
      <rect x="370.7" y="686.8" width="28.7" height="28.7" />
      <rect x="370.7" y="773" width="28.7" height="28.7" />
      <rect x="370.7" y="801.7" width="28.7" height="28.7" />
      <rect x="370.7" y="887.9" width="28.7" height="28.7" />
      <rect x="399.4" y="112.1" width="28.7" height="28.7" />
      <rect x="399.4" y="169.5" width="28.7" height="28.7" />
      <rect x="399.4" y="198.3" width="28.7" height="28.7" />
      <rect x="399.4" y="227" width="28.7" height="28.7" />
      <rect x="399.4" y="284.5" width="28.7" height="28.7" />
      <rect x="399.4" y="313.2" width="28.7" height="28.7" />
      <rect x="399.4" y="629.3" width="28.7" height="28.7" />
      <rect x="399.4" y="658" width="28.7" height="28.7" />
      <rect x="399.4" y="686.8" width="28.7" height="28.7" />
      <rect x="399.4" y="773" width="28.7" height="28.7" />
      <rect x="399.4" y="859.2" width="28.7" height="28.7" />
      <rect x="399.4" y="887.9" width="28.7" height="28.7" />
      <rect x="428.2" y="83.3" width="28.7" height="28.7" />
      <rect x="428.2" y="140.8" width="28.7" height="28.7" />
      <rect x="428.2" y="198.3" width="28.7" height="28.7" />
      <rect x="428.2" y="255.7" width="28.7" height="28.7" />
      <rect x="428.2" y="744.3" width="28.7" height="28.7" />
      <rect x="428.2" y="801.7" width="28.7" height="28.7" />
      <rect x="428.2" y="887.9" width="28.7" height="28.7" />
      <rect x="456.9" y="112.1" width="28.7" height="28.7" />
      <rect x="456.9" y="198.3" width="28.7" height="28.7" />
      <rect x="456.9" y="227" width="28.7" height="28.7" />
      <rect x="456.9" y="715.5" width="28.7" height="28.7" />
      <rect x="456.9" y="773" width="28.7" height="28.7" />
      <rect x="456.9" y="830.5" width="28.7" height="28.7" />
      <rect x="456.9" y="859.2" width="28.7" height="28.7" />
      <rect x="456.9" y="887.9" width="28.7" height="28.7" />
      <rect x="485.6" y="112.1" width="28.7" height="28.7" />
      <rect x="485.6" y="169.5" width="28.7" height="28.7" />
      <rect x="485.6" y="255.7" width="28.7" height="28.7" />
      <rect x="485.6" y="284.5" width="28.7" height="28.7" />
      <rect x="485.6" y="342" width="28.7" height="28.7" />
      <rect x="485.6" y="658" width="28.7" height="28.7" />
      <rect x="485.6" y="715.5" width="28.7" height="28.7" />
      <rect x="485.6" y="773" width="28.7" height="28.7" />
      <rect x="485.6" y="887.9" width="28.7" height="28.7" />
      <rect x="514.4" y="198.3" width="28.7" height="28.7" />
      <rect x="514.4" y="284.5" width="28.7" height="28.7" />
      <rect x="514.4" y="313.2" width="28.7" height="28.7" />
      <rect x="514.4" y="342" width="28.7" height="28.7" />
      <rect x="514.4" y="744.3" width="28.7" height="28.7" />
      <rect x="514.4" y="801.7" width="28.7" height="28.7" />
      <rect x="514.4" y="859.2" width="28.7" height="28.7" />
      <rect x="514.4" y="887.9" width="28.7" height="28.7" />
      <rect x="543.1" y="83.3" width="28.7" height="28.7" />
      <rect x="543.1" y="112.1" width="28.7" height="28.7" />
      <rect x="543.1" y="140.8" width="28.7" height="28.7" />
      <rect x="543.1" y="169.5" width="28.7" height="28.7" />
      <rect x="543.1" y="198.3" width="28.7" height="28.7" />
      <rect x="543.1" y="227" width="28.7" height="28.7" />
      <rect x="543.1" y="255.7" width="28.7" height="28.7" />
      <rect x="543.1" y="313.2" width="28.7" height="28.7" />
      <rect x="543.1" y="342" width="28.7" height="28.7" />
      <rect x="543.1" y="629.3" width="28.7" height="28.7" />
      <rect x="543.1" y="658" width="28.7" height="28.7" />
      <rect x="543.1" y="686.8" width="28.7" height="28.7" />
      <rect x="543.1" y="887.9" width="28.7" height="28.7" />
      <rect x="571.8" y="83.3" width="28.7" height="28.7" />
      <rect x="571.8" y="112.1" width="28.7" height="28.7" />
      <rect x="571.8" y="169.5" width="28.7" height="28.7" />
      <rect x="571.8" y="227" width="28.7" height="28.7" />
      <rect x="571.8" y="284.5" width="28.7" height="28.7" />
      <rect x="571.8" y="313.2" width="28.7" height="28.7" />
      <rect x="571.8" y="686.8" width="28.7" height="28.7" />
      <rect x="571.8" y="715.5" width="28.7" height="28.7" />
      <rect x="571.8" y="773" width="28.7" height="28.7" />
      <rect x="571.8" y="887.9" width="28.7" height="28.7" />
      <rect x="600.6" y="140.8" width="28.7" height="28.7" />
      <rect x="600.6" y="255.7" width="28.7" height="28.7" />
      <rect x="600.6" y="284.5" width="28.7" height="28.7" />
      <rect x="600.6" y="313.2" width="28.7" height="28.7" />
      <rect x="600.6" y="342" width="28.7" height="28.7" />
      <rect x="600.6" y="658" width="28.7" height="28.7" />
      <rect x="600.6" y="744.3" width="28.7" height="28.7" />
      <rect x="600.6" y="830.5" width="28.7" height="28.7" />
      <rect x="600.6" y="887.9" width="28.7" height="28.7" />
      <rect x="629.3" y="169.5" width="28.7" height="28.7" />
      <rect x="629.3" y="227" width="28.7" height="28.7" />
      <rect x="629.3" y="313.2" width="28.7" height="28.7" />
      <rect x="629.3" y="370.7" width="28.7" height="28.7" />
      <rect x="629.3" y="399.4" width="28.7" height="28.7" />
      <rect x="629.3" y="456.9" width="28.7" height="28.7" />
      <rect x="629.3" y="485.6" width="28.7" height="28.7" />
      <rect x="629.3" y="571.8" width="28.7" height="28.7" />
      <rect x="629.3" y="600.6" width="28.7" height="28.7" />
      <rect x="629.3" y="801.7" width="28.7" height="28.7" />
      <rect x="658" y="83.3" width="28.7" height="28.7" />
      <rect x="658" y="112.1" width="28.7" height="28.7" />
      <rect x="658" y="140.8" width="28.7" height="28.7" />
      <rect x="658" y="169.5" width="28.7" height="28.7" />
      <rect x="658" y="255.7" width="28.7" height="28.7" />
      <rect x="658" y="313.2" width="28.7" height="28.7" />
      <rect x="658" y="370.7" width="28.7" height="28.7" />
      <rect x="658" y="399.4" width="28.7" height="28.7" />
      <rect x="658" y="514.4" width="28.7" height="28.7" />
      <rect x="658" y="543.1" width="28.7" height="28.7" />
      <rect x="658" y="571.8" width="28.7" height="28.7" />
      <rect x="658" y="629.3" width="28.7" height="28.7" />
      <rect x="658" y="658" width="28.7" height="28.7" />
      <rect x="658" y="686.8" width="28.7" height="28.7" />
      <rect x="658" y="715.5" width="28.7" height="28.7" />
      <rect x="658" y="744.3" width="28.7" height="28.7" />
      <rect x="658" y="773" width="28.7" height="28.7" />
      <rect x="658" y="801.7" width="28.7" height="28.7" />
      <rect x="658" y="887.9" width="28.7" height="28.7" />
      <rect x="686.8" y="313.2" width="28.7" height="28.7" />
      <rect x="686.8" y="370.7" width="28.7" height="28.7" />
      <rect x="686.8" y="399.4" width="28.7" height="28.7" />
      <rect x="686.8" y="456.9" width="28.7" height="28.7" />
      <rect x="686.8" y="485.6" width="28.7" height="28.7" />
      <rect x="686.8" y="514.4" width="28.7" height="28.7" />
      <rect x="686.8" y="543.1" width="28.7" height="28.7" />
      <rect x="686.8" y="571.8" width="28.7" height="28.7" />
      <rect x="686.8" y="600.6" width="28.7" height="28.7" />
      <rect x="686.8" y="658" width="28.7" height="28.7" />
      <rect x="686.8" y="773" width="28.7" height="28.7" />
      <rect x="686.8" y="830.5" width="28.7" height="28.7" />
      <rect x="686.8" y="887.9" width="28.7" height="28.7" />
      <rect x="715.5" y="370.7" width="28.7" height="28.7" />
      <rect x="715.5" y="456.9" width="28.7" height="28.7" />
      <rect x="715.5" y="514.4" width="28.7" height="28.7" />
      <rect x="715.5" y="600.6" width="28.7" height="28.7" />
      <rect x="715.5" y="629.3" width="28.7" height="28.7" />
      <rect x="715.5" y="658" width="28.7" height="28.7" />
      <rect x="715.5" y="715.5" width="28.7" height="28.7" />
      <rect x="715.5" y="773" width="28.7" height="28.7" />
      <rect x="715.5" y="887.9" width="28.7" height="28.7" />
      <rect x="744.3" y="370.7" width="28.7" height="28.7" />
      <rect x="744.3" y="456.9" width="28.7" height="28.7" />
      <rect x="744.3" y="514.4" width="28.7" height="28.7" />
      <rect x="744.3" y="543.1" width="28.7" height="28.7" />
      <rect x="744.3" y="629.3" width="28.7" height="28.7" />
      <rect x="744.3" y="658" width="28.7" height="28.7" />
      <rect x="744.3" y="773" width="28.7" height="28.7" />
      <rect x="744.3" y="801.7" width="28.7" height="28.7" />
      <rect x="744.3" y="859.2" width="28.7" height="28.7" />
      <rect x="744.3" y="887.9" width="28.7" height="28.7" />
      <rect x="773" y="313.2" width="28.7" height="28.7" />
      <rect x="773" y="370.7" width="28.7" height="28.7" />
      <rect x="773" y="399.4" width="28.7" height="28.7" />
      <rect x="773" y="428.2" width="28.7" height="28.7" />
      <rect x="773" y="485.6" width="28.7" height="28.7" />
      <rect x="773" y="514.4" width="28.7" height="28.7" />
      <rect x="773" y="543.1" width="28.7" height="28.7" />
      <rect x="773" y="629.3" width="28.7" height="28.7" />
      <rect x="773" y="658" width="28.7" height="28.7" />
      <rect x="773" y="686.8" width="28.7" height="28.7" />
      <rect x="773" y="715.5" width="28.7" height="28.7" />
      <rect x="773" y="744.3" width="28.7" height="28.7" />
      <rect x="773" y="773" width="28.7" height="28.7" />
      <rect x="801.7" y="370.7" width="28.7" height="28.7" />
      <rect x="801.7" y="456.9" width="28.7" height="28.7" />
      <rect x="801.7" y="485.6" width="28.7" height="28.7" />
      <rect x="801.7" y="600.6" width="28.7" height="28.7" />
      <rect x="801.7" y="744.3" width="28.7" height="28.7" />
      <rect x="801.7" y="801.7" width="28.7" height="28.7" />
      <rect x="801.7" y="859.2" width="28.7" height="28.7" />
      <rect x="830.5" y="370.7" width="28.7" height="28.7" />
      <rect x="830.5" y="399.4" width="28.7" height="28.7" />
      <rect x="830.5" y="428.2" width="28.7" height="28.7" />
      <rect x="830.5" y="456.9" width="28.7" height="28.7" />
      <rect x="830.5" y="514.4" width="28.7" height="28.7" />
      <rect x="830.5" y="600.6" width="28.7" height="28.7" />
      <rect x="830.5" y="629.3" width="28.7" height="28.7" />
      <rect x="830.5" y="658" width="28.7" height="28.7" />
      <rect x="830.5" y="686.8" width="28.7" height="28.7" />
      <rect x="830.5" y="801.7" width="28.7" height="28.7" />
      <rect x="830.5" y="859.2" width="28.7" height="28.7" />
      <rect x="830.5" y="887.9" width="28.7" height="28.7" />
      <rect x="859.2" y="313.2" width="28.7" height="28.7" />
      <rect x="859.2" y="342" width="28.7" height="28.7" />
      <rect x="859.2" y="399.4" width="28.7" height="28.7" />
      <rect x="859.2" y="514.4" width="28.7" height="28.7" />
      <rect x="859.2" y="543.1" width="28.7" height="28.7" />
      <rect x="859.2" y="571.8" width="28.7" height="28.7" />
      <rect x="859.2" y="600.6" width="28.7" height="28.7" />
      <rect x="859.2" y="629.3" width="28.7" height="28.7" />
      <rect x="859.2" y="658" width="28.7" height="28.7" />
      <rect x="859.2" y="686.8" width="28.7" height="28.7" />
      <rect x="859.2" y="744.3" width="28.7" height="28.7" />
      <rect x="859.2" y="801.7" width="28.7" height="28.7" />
      <rect x="859.2" y="859.2" width="28.7" height="28.7" />
      <rect x="859.2" y="887.9" width="28.7" height="28.7" />
      <rect x="887.9" y="342" width="28.7" height="28.7" />
      <rect x="887.9" y="399.4" width="28.7" height="28.7" />
      <rect x="887.9" y="485.6" width="28.7" height="28.7" />
      <rect x="887.9" y="571.8" width="28.7" height="28.7" />
      <rect x="887.9" y="658" width="28.7" height="28.7" />
      <rect x="887.9" y="715.5" width="28.7" height="28.7" />
      <rect x="887.9" y="773" width="28.7" height="28.7" />
      <rect x="887.9" y="859.2" width="28.7" height="28.7" />
      <path d="M83.3,83.3v201.1h201.1V83.3H83.3ZM112.1,112.1h143.7v143.7H112.1V112.1Z" />
      <rect x="140.8" y="140.8" width="86.2" height="86.2" />
      <path d="M916.7,83.3h-201.1v201.1h201.1V83.3ZM887.9,112.1v143.7h-143.7V112.1h143.7Z" />
      <rect x="773" y="140.8" width="86.2" height="86.2" />
      <path d="M83.3,916.7h201.1v-201.1H83.3v201.1ZM112.1,887.9v-143.7h143.7v143.7H112.1Z" />
      <rect x="140.8" y="773" width="86.2" height="86.2" />
      <path d="M573.6,493.2l-31.5-54.5c-2.4-4.2-6.9-6.8-11.7-6.8h-62.9c-4.8,0-9.3,2.6-11.7,6.8l-31.5,54.5c-2.4,4.2-2.4,9.3,0,13.5l31.5,54.5c2.4,4.2,6.9,6.8,11.7,6.8h62.9c4.8,0,9.3-2.6,11.7-6.8l31.5-54.5c2.4-4.2,2.4-9.3,0-13.5ZM470.8,467.8c0-5,4-9,9-9h37.3c5,0,9,4,9,9v1.5c0,5-4,9-9,9h-37.3c-5,0-9-4-9-9v-1.5ZM516.6,532.1c0,5-4,9-9,9h-18.1c-5,0-9-4-9-9v-1.5c0-5,4-9,9-9h18.1c5,0,9,4,9,9v1.5ZM545.4,500.8c0,5-4,9-9,9h-75.9c-5,0-9-4-9-9v-1.5c0-5,4-9,9-9h75.9c5,0,9,4,9,9v1.5Z" />
    </svg>
  ),
  [IconName.GlobalTrendsMicroMance]: (
    <svg aria-hidden={true} viewBox="0 0 21 26" width={21} height={26}>
      <g fill="#343333" clipPath="url(#a)">
        <path d="M14 10.95H0v1.37h14v-1.37Zm-1.4-1.37H0v1.37h12.6V9.58Z" />
        <path d="M11.2 8.21H0v1.37h11.2V8.2Z" />
        <path d="M9.33 6.84H0v1.37h9.33V6.84ZM8 5.47H0v1.37h8V5.47ZM6.78 4.1H0v1.37h6.78V4.11ZM4.2 2.74H0V4.1h4.2V2.74Z" />
        <path d="M6.22 1.27H0V8.3h6.22V1.27Z" />
        <path d="M4.67 2.74H3.1V4.1h1.56V2.74ZM6.22 4.1H4.67v1.37h1.55V4.11Zm1.56 1.37H6.22v1.37h1.56V5.47Zm1.55 1.37H7.78v1.37h1.55V6.84Zm1.56 1.37H9.33v1.37h1.56V8.2Z" />
        <path d="M12.45 9.58h-1.56v1.37h1.56V9.58Zm6.22 1.37H17.1v1.37h1.56v-1.37Z" />
        <path d="M17.11 9.58h-1.56v2.74h1.56V9.58Z" />
        <path d="M15.56 8.21H14v4.1h1.56v-4.1ZM14 6.84h-1.56v5.48H14V6.84Z" />
        <path d="M12.45 5.47h-1.56v6.85h1.56V5.47Z" />
        <path d="M10.89 4.1H9.33v6.85h1.56V4.1ZM9.33 2.74H7.78v9.58h1.55V2.74Zm-1.55-1.5H6.22v9.7h1.56v-9.7Zm-4.67.13H1.55v1.37h1.56V1.37Zm17.11 10.95H3.11v1.36h17.11v-1.36Z" />
        <path d="M3.11 12.32H1.55v1.36h1.56v-1.36Z" />
        <path d="M3.11 12.32H1.55v1.36h1.56v-1.36Zm-1.55-1.37H0v1.37h1.56v-1.37Z" />
        <path d="M3.11 12.32H1.55v1.36h1.56v-1.36Zm1.98-1.37H0v1.37h5.09v-1.37Z" />
        <path d="M1.56 10.95H0v1.37h1.56v-1.37Zm4.04 1.37H0v1.36h5.6v-1.36Zm8.4 1.36H0v1.37h14v-1.37Zm-1.4 1.37H0v1.37h12.6v-1.37Zm-1.4 1.37H0v1.37h11.2v-1.37Z" />
        <path d="M9.33 17.79H0v1.37h9.33v-1.37ZM8 19.16H0v1.37h8v-1.37Zm-1.22 1.37H0v1.37h6.78v-1.37Z" />
        <path d="M4.2 21.9H0v1.36h4.2V21.9Z" />
        <path d="M6.22 17.33H0v7.23h6.22v-7.23Z" />
        <path d="M4.44 21.67H2.9v1.36h1.55v-1.36Zm1.78-1.14H4.67v1.37h1.55v-1.37Zm1.56-1.37H6.22v1.37h1.56v-1.37Zm1.55-1.37H7.78v1.37h1.55v-1.37Zm1.56-1.37H9.33v1.37h1.56v-1.37Zm1.56-1.37h-1.56v1.37h1.56v-1.37Zm6.22-1.37H17.1v1.37h1.56v-1.37Z" />
        <path d="M17.11 13.68h-1.56v2.74h1.56v-2.74Z" />
        <path d="M15.56 13.68H14v4.1h1.56v-4.1Zm-1.56 0h-1.56v5.48H14v-5.48Z" />
        <path d="M12.45 13.68h-1.56v6.85h1.56v-6.85Z" />
        <path d="M10.89 15.05H9.33v6.84h1.56v-6.84Zm-1.56-1.37H7.78v9.58h1.55v-9.58Zm-1.55 1.37H6.22v9.58h1.56v-9.58Zm-4.67 8.21H1.55v1.37h1.56v-1.37Z" />
        <path d="M20.22 12.32H3.11v1.36h17.11v-1.36Z" />
        <path d="M3.11 12.32H1.55v1.36h1.56v-1.36Z" />
        <path d="M3.11 12.32H1.55v1.36h1.56v-1.36Zm-1.55 1.36H0v1.37h1.56v-1.37Z" />
        <path d="M3.11 12.32H1.55v1.36h1.56v-1.36Zm1.98 1.36H0v1.37h5.09v-1.37Z" />
        <path d="M1.56 13.68H0v1.37h1.56v-1.37Zm4.04-1.36H0v1.36h5.6v-1.36Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20.22v26H0z" />
        </clipPath>
      </defs>
    </svg>
  ),
  [IconName.GlobalTrendsDWM]: (
    <svg aria-hidden={true} viewBox="0 0 27 24" width={27} height={24}>
      <path
        fill="#343333"
        d="M26.35 5.41h-1.38V4.03h-1.4v-1.4H22.2V1.25h-2.43V0H6.6v1.25H4.16v1.38H2.78v1.4h-1.4v1.38H0v9.72h1.38v1.38h1.4v1.38h1.38v1.39h9.72v1.4h2.76v1.38h1.38v1.38h2.78v-4.17h1.39V17.9h1.38v-1.38h1.4v-1.38h1.38V5.4Z"
      />
    </svg>
  ),
  [IconName.GlobalTrendsOnTheSamePage]: (
    <svg aria-hidden={true} viewBox="0 0 27 25" width={27} height={25}>
      <path
        fill="#343333"
        d="M26.35 10.7H25.3V9.3h-2.11V7.9h-2.56l-.1-.1 1.3-2.25-1.21-.71 1.05-1.82-1.22-.7.53-.92L18.55 0l-.53.9L16.8.22l-1.06 1.82-1.2-.7-1.36 2.35-1.36-2.35-1.21.7L9.55.2 8.33.9 7.8 0 5.38 1.4l.52.92-1.22.7 1.05 1.82-1.21.7 1.25 2.18-.17.17H3.16V9.3h-2.1v1.4H0v2.82h1.05v1.4h2.11v1.4h2.56l.09.1-1.3 2.25 1.22.71-1.05 1.82 1.22.7-.52.92 2.42 1.4.53-.91 1.22.7 1.06-1.82 1.2.7 1.37-2.35 1.35 2.35 1.21-.7L16.8 24l1.22-.7.53.9 2.43-1.39-.53-.92 1.22-.7-1.05-1.82 1.21-.71-1.3-2.25.1-.1h2.56v-1.4h2.1v-1.4h1.06V10.7Z"
      />
    </svg>
  ),
  [IconName.GlobalTrendsMaleCasting]: (
    <svg aria-hidden={true} viewBox="0 0 26 26" width={26} height={26}>
      <path
        fill="#343333"
        d="M23.72 11.86v-1.32H22.4V9.22h-1.32V7.91h-1.32V6.59h-1.31V5.27h-1.32V3.95H15.8V2.64h-1.32V1.32h-1.31V0h-1.32v1.32h-1.32v1.32H9.22v1.31H7.91v1.32H6.59v1.32H5.27V7.9H3.95v1.31H2.64v1.32H1.32v1.32H0v2.63h3.95v10.54h17.13V14.5h3.95v-2.63h-1.31Z"
      />
    </svg>
  ),
  // Guys that get it
  [IconName.GlobalTrendsFutureProofing]: (
    <svg aria-hidden={true} viewBox="0 0 24 21" width={24} height={21}>
      <path
        fill="#343333"
        d="M23.03 4h-1.36V1.33h-1.35V0H2.72v1.33H1.36V4H0v12.02h1.36v2.67h1.36v1.34h17.6v-1.34h1.35v-2.67h1.36V4Z"
      />
    </svg>
  ),
  [IconName.GlobalTrendsGuysThatGetIt]: (
    <svg aria-hidden={true} viewBox="0 0 26 26" width={26} height={26}>
      <path
        fill="#343333"
        d="M25.03 11.86h-1.31v-1.32h-2.64V9.22h1.32V3.95h-6.6v1.32h-1.32V1.32h-1.31V0h-1.32v1.32h-1.32v3.95H9.22V3.95H2.64v5.27h1.31v1.32H1.32v1.32H0v1.32h1.32v1.31h2.63v1.32H2.64v5.27h6.58v-1.32h1.32v3.96h1.32v1.31h1.32v-1.31h1.31v-3.96h1.32v1.32h6.59v-5.27h-1.32V14.5h2.64v-1.31h1.31v-1.32Z"
      />
    </svg>
  ),
  [IconName.FeatureDiscover]: (
    <svg aria-hidden={true} viewBox="0 0 60 60" width={60} height={60}>
      <path
        fill="#343333"
        d="M29.69 0A29.72 29.72 0 0 0 0 29.7a29.72 29.72 0 0 0 29.69 29.68A29.72 29.72 0 0 0 59.37 29.7 29.72 29.72 0 0 0 29.7 0Zm14.43 20.77-6 14.99a4.25 4.25 0 0 1-2.36 2.36l-15 6a4.26 4.26 0 0 1-4.56-.94c-1.2-1.2-1.57-3-.94-4.57l6-15a4.25 4.25 0 0 1 2.35-2.36l15-6a4.24 4.24 0 0 1 5.51 5.52Z"
      />
    </svg>
  ),
  [IconName.FeatureInstantMatch]: (
    <svg aria-hidden={true} viewBox="0 0 67 67" width={67} height={67}>
      <path
        fill="#343333"
        d="M28 14.85H17.04a2.2 2.2 0 0 0-2.2 2.19V28c0 1.21.99 2.2 2.2 2.2H28a2.2 2.2 0 0 0 2.2-2.2V17.04a2.2 2.2 0 0 0-2.2-2.2ZM25.37 25.8h-5.7a.44.44 0 0 1-.44-.44v-5.7c0-.24.2-.44.44-.44h5.7c.24 0 .44.2.44.44v5.7c0 .24-.2.44-.44.44Zm13.59 4.4h10.97a2.2 2.2 0 0 0 2.19-2.2V17.04a2.2 2.2 0 0 0-2.2-2.2H38.97a2.2 2.2 0 0 0-2.19 2.2V28c0 1.21.98 2.2 2.2 2.2Zm2.63-10.97h5.7c.25 0 .44.2.44.44v5.7c0 .24-.2.44-.43.44h-5.7a.44.44 0 0 1-.44-.44v-5.7c0-.24.2-.44.44-.44ZM28 36.78H17.04a2.2 2.2 0 0 0-2.2 2.19v10.96c0 1.2.99 2.2 2.2 2.2H28a2.2 2.2 0 0 0 2.2-2.2V38.97a2.2 2.2 0 0 0-2.2-2.2Zm-2.63 10.96h-5.7a.44.44 0 0 1-.44-.44v-5.7c0-.24.2-.44.44-.44h5.7c.24 0 .44.2.44.44v5.7c0 .24-.2.44-.44.44Zm24.56-10.96H38.96a2.2 2.2 0 0 0-2.19 2.19v10.96c0 1.21.98 2.2 2.2 2.2h10.96a2.2 2.2 0 0 0 2.19-2.2V38.97a2.2 2.2 0 0 0-2.2-2.2ZM4.98 20.33a2.2 2.2 0 0 0 2.2-2.2V9.38c0-1.21.98-2.2 2.19-2.2h8.77a2.2 2.2 0 0 0 0-4.38H9.37a6.58 6.58 0 0 0-6.58 6.58v8.77c0 1.2.98 2.19 2.2 2.19Zm57 26.31a2.2 2.2 0 0 0-2.19 2.2v8.76c0 1.2-.98 2.2-2.19 2.2h-8.77a2.2 2.2 0 0 0 0 4.38h8.77a6.59 6.59 0 0 0 6.58-6.58v-8.77a2.2 2.2 0 0 0-2.2-2.2ZM57.6 2.8h-8.77a2.2 2.2 0 0 0 0 4.38h8.77c1.2 0 2.2.98 2.2 2.19v8.77a2.2 2.2 0 0 0 4.38 0V9.37a6.59 6.59 0 0 0-6.58-6.58Zm-39.46 57H9.37a2.2 2.2 0 0 1-2.2-2.2v-8.77a2.2 2.2 0 0 0-4.38 0v8.77a6.59 6.59 0 0 0 6.58 6.58h8.77a2.2 2.2 0 0 0 0-4.39Z"
      />
    </svg>
  ),
};

type OwnProps = {
  size?: 'md' | 'sm' | 'xsm' | 'stretch';
  name?: (typeof IconName)[keyof typeof IconName];
  color?: 'default' | 'inverse' | 'brand';
  a11yLabel?: string;
  isInline?: boolean;
};

type IconProps = OwnProps;

const Icon = ({ size = 'stretch', color, name, a11yLabel, isInline }: IconProps) => {
  const className = cx({
    icon: true,
    [`icon--${size}`]: true,
    [`color-${color}`]: color,
    'icon--inline': isInline,
  });

  return (
    <div className={className} aria-label={a11yLabel} role={a11yLabel ? 'img' : undefined}>
      {name ? mapNameToIcon[name] : null}
    </div>
  );
};

Icon.Name = IconName;

export default Icon;
